import { DownloadS3File } from "./downloadS3File";

export function GetSubbedUnis (getSubbedUnisCallback) {

        DownloadS3File(
            "TestFiles/EnterpriseData/suffix_list_lite.json",
            gotSuffixListCallback,
            "com.rubenwood.unityaatesting"
        );

        function gotSuffixListCallback(data) {
            const suffixList = JSON.parse(data).suffixList;

            getSubbedUnisCallback(suffixList)
        }
}